"use client";

import { useState } from "react";
import DrawResults from "./DrawResults";

export default function BetKeypad({ onNumberPress, onDelete, onAddBets }) {
  const [selectedType, setSelectedType] = useState("COMBINATION");
  const [numbers, setNumbers] = useState([]);
  const [showInput, setShowInput] = useState(false); // Toggle for keypad and text input
  const [isToggled, setIsToggled] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState([]); // Track selected keys

  const drawTimes = [
    {
      time: "2:00 PM",
      numbers: [
        {
          num: 1,
          color: "[#0E64D1] ",
          gredient: `conic-gradient(
          from 0deg,
       #0E64D1 0deg 40deg,
            white 40deg 90deg,
            #0E64D1 90deg 130deg,
            white 130deg 180deg,
            #0E64D1 180deg 220deg,
            white 220deg 270deg,
            #0E64D1 270deg 310deg,
            white 310deg 360deg
        )`,
        },

        {
          num: 2,
          color: "green-400",
          gredient: `conic-gradient(
        from 0deg,
    #0ED173 0deg 40deg,
            white 40deg 90deg,
            #0ED173 90deg 130deg,
            white 130deg 180deg,
            #0ED173 180deg 220deg,
            white 220deg 270deg,
            #0ED173 270deg 310deg,
            white 310deg 360deg
      )`,
        },

        {
          num: 3,
          color: "red-600 background",
          gredient: `conic-gradient(
          from 0deg,
           #D92000 0deg 40deg,
            white 40deg 90deg,
            #D92000 90deg 130deg,
            white 130deg 180deg,
            #D92000 180deg 220deg,
            white 220deg 270deg,
            #D92000 270deg 310deg,
            white 310deg 360deg
        )`,
        },
      ],
    },

    {
      time: "5:00 PM",
      numbers: [
        {
          num: 0,
          color: "[#292A41] ",
          gredient: `conic-gradient(
          from 0deg,
       #292A41 0deg 40deg,
            white 40deg 90deg,
            #292A41 90deg 130deg,
            white 130deg 180deg,
            #292A41 180deg 220deg,
            white 220deg 270deg,
            #292A41 270deg 310deg,
            white 310deg 360deg
        )`,
        },

        {
          num: 0,
          color: "[#292A41] ",
          gredient: `conic-gradient(
          from 0deg,
       #292A41 0deg 40deg,
            white 40deg 90deg,
            #292A41 90deg 130deg,
            white 130deg 180deg,
            #292A41 180deg 220deg,
            white 220deg 270deg,
            #292A41 270deg 310deg,
            white 310deg 360deg
        )`,
        },
        {
          num: 0,
          color: "[#292A41] ",
          gredient: `conic-gradient(
          from 0deg,
       #292A41 0deg 40deg,
            white 40deg 90deg,
            #292A41 90deg 130deg,
            white 130deg 180deg,
            #292A41 180deg 220deg,
            white 220deg 270deg,
            #292A41 270deg 310deg,
            white 310deg 360deg
        )`,
        },
      ],
    },
    {
      time: "9:00 PM",
      numbers: [
        {
          num: 0,
          color: "[#292A41] ",
          gredient: `conic-gradient(
          from 0deg,
       #292A41 0deg 40deg,
            white 40deg 90deg,
            #292A41 90deg 130deg,
            white 130deg 180deg,
            #292A41 180deg 220deg,
            white 220deg 270deg,
            #292A41 270deg 310deg,
            white 310deg 360deg
        )`,
        },

        {
          num: 0,
          color: "[#292A41] ",
          gredient: `conic-gradient(
            from 0deg,
         #292A41 0deg 40deg,
              white 40deg 90deg,
              #292A41 90deg 130deg,
              white 130deg 180deg,
              #292A41 180deg 220deg,
              white 220deg 270deg,
              #292A41 270deg 310deg,
              white 310deg 360deg
          )`,
        },

        {
          num: 0,
          color: "[#292A41] ",
          gredient: `conic-gradient(
            from 0deg,
         #292A41 0deg 40deg,
              white 40deg 90deg,
              #292A41 90deg 130deg,
              white 130deg 180deg,
              #292A41 180deg 220deg,
              white 220deg 270deg,
              #292A41 270deg 310deg,
              white 310deg 360deg
          )`,
        },
  
      ],
    },
  ];

  const handleKeyPress = (key) => {
    setSelectedKeys((prev) => {
      // If key is already selected, remove it; otherwise, add it
      if (prev.includes(key)) {
        return prev.filter((k) => k !== key);
      } else {
        return [...prev, key];
      }
    });

    if (typeof key === "number") {
      onNumberPress(key);
    } else if (key === "<") {
      onDelete();
    } else {
      onAddBets();
    }
  };

  return (
    <>
      <div className="bg-black bg-opacity-50 rounded-[35px] p-4 border-2 border-yellow-300">
        <DrawResults times={drawTimes} />

        {/* Bet Types */}
        <div className="grid grid-cols-3 gap-2 py-4 mt-6">
          {["COMBINATION", "STRAIGHT", "RAMBLE"].map((type) => (
            <div
              key={type}
              className="relative py-8  rounded-lg"
              style={{
                background: "linear-gradient(360deg, #FFFFFF 0%, #D4DEEB 100%)",
              }}
            >
              <button
                onClick={() => setSelectedType(type)}
                className={`absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-2 text-xs font-bold rounded-full ${
                  selectedType === type
                    ? "bg-gradient-to-b from-[#FF0000] via-[#6D1010] to-[#FF0000] text-yellow-200"
                    : "bg-gradient-to-b from-[#65758B] via-[#12131A] to-[#65758B] text-gray-200"
                }`}
              >
                {type}
              </button>
            </div>
          ))}
        </div>

        {/* Conditional Rendering for Keypad and Text Input */}
        {showInput ? (
          // Text Input Field
          <div className="w-full max-w-md bg-[#1A1A1A] rounded-md p-.5">
            <form>
              {/* Textarea */}
              <div className="mb-1">
                <textarea
                  className="w-full h-52 bg-white text-[#65758B] rounded-xl p-2 text-xs resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder={`Type or paste your comma-separated bets here.\nExample format: 123-5,234-5r`}
                />
              </div>

              {/* Checkbox */}

              <div className="flex items-start gap-4 ">
                <div className="relative flex items-center ">
                  <div
                    className={`w-8 h-4 flex items-center rounded-full p-1 cursor-pointer transition-colors ${
                      isToggled ? "bg-[#0E64D1]" : "bg-gray-600"
                    }`}
                    onClick={() => setIsToggled(!isToggled)} // Toggle state on click
                  >
                    <div
                      className={`w-3.5 h-3.5 bg-white rounded-full shadow-md transform transition-transform ${
                        isToggled ? "translate-x-3" : "translate-x-0"
                      }`}
                    ></div>
                  </div>
                </div>

                <div className="flex items-start flex-col gap-2 mb-4 text-white">
                  <span className="text-xs font-normal leading-none">
                    Allow the multiplication of ramble bets.
                  </span>

                  <span className="text-xs font-bold">
                    123-1r = P6.00 | 122-1r = P3.00
                  </span>
                </div>
              </div>

              {/* Example Calculations */}
            </form>
          </div>
        ) : (
          // Keypad
          <div className="grid grid-cols-4 gap-2">
            {[1, 2, 3, 4, 5, 6, 7, 8, "ADD\nBETS", 9, 0, "<"].map((key) => (
              <button
                key={key}
                onClick={() => handleKeyPress(key)}
                className={`aspect-square rounded-full ${
                  key === "ADD\nBETS"
                    ? "text-[20px] leading-none font-bold"
                    : key === "<"
                    ? "text-6xl"
                    : "text-4xl font-bold"
                } flex items-center justify-center`}
                style={{
                  // border: selectedKeys.includes(key)
                  // ? "10px solid linear-gradient(180deg, #FF0000 0%, #6D1010 50%, #FF0000 100%)"
                  // : "linear-gradient(180deg, #FBD115 0%, #FFF9C9 31%, #FFF9C9 48%, #FFE500 52%, #FC9703 100%)",

                  color: selectedKeys.includes(key) ? "#FDE68A" : "#6D1010",
                  background: selectedKeys.includes(key)
                    ? "linear-gradient(180deg, #FF0000 0%, #6D1010 50%, #FF0000 100%)"
                    : "linear-gradient(180deg, #FBD115 0%, #FFF9C9 31%, #FFF9C9 48%, #FFE500 52%, #FC9703 100%)",
                }}
              >
                {key}
              </button>
            ))}
          </div>
        )}

        {/* Switch Between Keypad and Text Input */}
        <div className="grid grid-cols-2 gap-2 pt-4 font-semibold">
          <button
            className="text-blue-500 py-2 rounded-full border border-blue-700"
            onClick={() => setShowInput(!showInput)}
          >
            {showInput ? "Keypads" : "Text Field"}
          </button>
          <button
            className={` py-2 rounded-full bg-[#0E64D1] ${
              showInput
                ? "bg-[#0E64D1] text-white"
                : "bg-[#34394B] text-[#71758A]"
            } `}
          >
            Add Text Bet
          </button>
        </div>
      </div>
    </>
  );
}
